<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        <div class="div_loading">
            <div class="my-container" [hidden]="!loading">
                <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
            </div>
        </div>
        <span>
            <span>{{ title }}</span>
        </span>
        <span (click)="close()">
            <mat-icon class="close">close</mat-icon>
        </span>
    </div>
</div>


<form [formGroup]="form1_group" (ngSubmit)="check_access(type_task,1)">
    <div mat-dialog-content class="matDialogContent">
        <div class="row pe1">

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding'
                [ngClass]="{width100:type_task==3}">
                <label for="customer" class='wh-label'>
                    <span *ngIf="lang == 1"> نام مشتری: </span>
                    <span *ngIf="lang == 2"> ---- : </span>
                    <span (click)="reset_input(24)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="customer_title" (click)="load_services(0,24)"
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="customer" [hidden]="true" [required]="required()" readonly>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding'
                [ngClass]="{width100:type_task==3}">
                <label for="seleton_id" class='wh-label'>
                    <span class="bookmark" (click)="select_invoice()" [hidden]="type_task == 3">
                        <i class="fas fa-bookmark cursor"></i>
                    </span>
                    <span (click)="reset_input(32)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <span *ngIf="lang == 1"> انتخاب فاکتور : </span>
                    <input class="wh-input" formControlName="seleton_title" (click)="load_services(0,32)"
                        [required]="required() && !form1_group.get('tip')!.value" readonly
                        [attr.disabled]="form1_group.get('tip')!.value">
                    <input class="wh-input" formControlName="seleton_id" [hidden]="true"
                        [required]="required() && !form1_group.get('tip')!.value" readonly>
                </label>
            </div>


            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding'
                [ngClass]="{width100:type_task==3}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> شرح : </span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <input class='wh-input' formControlName="title" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="true">
                <label for="sort" class='wh-label'>
                    <span *ngIf="lang == 1"> ترتیب : </span>
                    <span *ngIf="lang == 2"> Sort : </span>
                    <input class='wh-input' formControlName="sort" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding'
                [ngClass]="{width100:type_task==3}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> تیپ : </span>
                    <span *ngIf="lang == 2"> --- : </span>
                    <span (click)="reset_input(225)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="tip_title" (click)="load_services(0,225)"
                        [required]="required() && !form1_group.get('seleton_id')!.value" readonly
                        [attr.disabled]="form1_group.get('seleton_id')!.value">
                    <input class="wh-input" formControlName="tip"
                        [required]="required() && !form1_group.get('seleton_id')!.value" readonly [hidden]="true">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding'
                [ngClass]="{width100:type_task==3}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> وضعیت : </span>
                    <span *ngIf="lang == 2"> Status : </span>
                    <span (click)="reset_input(223)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="status_title" (click)="load_services(0,223)"
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="status_id" [required]="required()" readonly
                        [hidden]="true">
                </label>
            </div>


        </div>

        <div class="row">
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding"
                *ngFor="let x of list_cate2;let i = index">
                <label for="" class='wh-label'>
                    <span *ngIf="lang == 1"> {{ x.wharehouse_material_cate_title }} ({{ x.count }}) : </span>
                    <input class="wh-input"
                        (click)="select_material(i,171,x.wharehouse_material_cate_id,x.wharehouse_material_cate_title)"
                        readonly [value]="x.sum | number"
                        [ngStyle]="{ 'background':x.count > 0 ? '#acdbac' : '#dba6a6'}" readonly>
                    <input class="wh-input" [hidden]="true" readonly>
                </label>
            </div>
        </div>
    </div>

    <div mat-dialog-actions class="matDialogActions">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 div_panding" style="text-align: right;"
            [ngClass]="{width100:type_task == 3}">
            <button type="submit" [disabled]="!form1_group.valid || readonly == true" class="btn_pe"
                [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 1 || type_task == 2" [hidden]="readonly"
                [hidden]="type_task == 3">
                <span *ngIf="lang == 2">Save</span>
                <span *ngIf="lang == 1">ذخیره</span>
            </button>
            <button type="button" (click)="open_contract()" [hidden]="type_task == 3">متن قرارداد</button>
            <button type="button" (click)="open_invoice()" [hidden]="type_task == 3">جزئیات</button>
            <a [href]="'/ckd-letter/'+token" target="_blank">
                <button type="button" [hidden]="type_task == 3">نامه</button>
            </a>
            <a [href]="'/ckd-list/'+token" target="_blank" target="_blank">
                <button type="button" [hidden]="type_task == 3">متریال</button>
            </a>
            <a [href]="'/tr-ckd/'+token" target="_blank" target="_blank">
                <button type="button" [hidden]="type_task == 3">پیش فاکتور داخلی</button>
            </a>
            <a [href]="'/invoice2/'+token" target="_blank" target="_blank" *ngIf="form1_group.get('seleton_id')!.value">
                <button type="button" [hidden]="type_task == 3">پیش فاکتور مشتری</button>
            </a>

            <button type="button" (click)="search(1)" class="btn_pe" [ngClass]="{btn_en:lang == 2}"
                *ngIf="type_task == 3">
                <span *ngIf="lang == 2">Search</span>
                <span *ngIf="lang == 1">جستجو</span>
            </button>
            <button type="button" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3"
                (click)="search(2)">
                <span *ngIf="lang == 2">Excel</span>
                <span *ngIf="lang == 1">خروجی اکسل</span>
            </button>
        </div>

        <div [hidden]="type_task == 3" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 div_panding"
            style="text-align: right;padding-top:8px">
            (
            قیمت کل بدون تخفیف {{ sum_all | number }} تومان
            )

            (
            مقدار تخفیف {{ discount_all | number }} تومان
            )

            <span>
                (
                قیمت با تخفیف
                {{ sum_with_discount | number }} تومان
                )
            </span>
            +
            <span>
                (
                ارزش افزوده
                {{ tax | number }} تومان
                )
            </span>

            <span style="background-color: #8df178">
                (
                قیمت نهایی
                {{ sum_final | number }} تومان
                )
            </span>

        </div>

    </div>
</form>